import { createContext, useState } from 'react';
import api from 'services/api';

export const DashboardContext = createContext();

export const DashboardProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);

  const getDashboard = async ({ params, cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/WMS/Dashboard/Portal', { params });
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <DashboardContext.Provider value={{ getLoading, getDashboard }}>
      {children}
    </DashboardContext.Provider>
  );
};
